<template>
  <div class="pointer-events-none absolute inset-x-0 bottom-0 flex flex-col gap-y-1 px-4 text-white" :class="variantClasses.container">
    <p class="font-Spectral font-light leading-5" :class="variantClasses.provider">
      {{ providerName }}
    </p>
    <p class="font-Spectral font-medium capitalize tracking-[0.5px]" :class="variantClasses.title">
      {{ title }}
    </p>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  providerName: string;
  title: string;
  variant?: 'small' | 'large';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'small',
});

const variantClasses = computed(() =>
  props.variant === 'large'
    ? { container: 'pb-6', provider: 'text-[17px] leading-6', title: 'line-clamp-3 text-[20px] leading-7' }
    : { container: 'pb-4', provider: 'text-[14px]', title: 'line-clamp-2 text-[17px] leading-6' },
);
</script>
